import { useState } from "react";
import reactLogo from "./assets/react.svg";

import "./App.css";
import CherryLoveQuotesApp from "./CherryLoveQuotesApp";

function App() {
  const [count, setCount] = useState(0);

  return (
    <>
      <CherryLoveQuotesApp />
    </>
  );
}

export default App;
